/**
 * Created by afuhr on 27.06.2017.
 */
import {FormGroup} from "@angular/forms";
export class PasswordChangeValidation {

  static passwordMatchValidation(passwordFormControlName = 'password', passwordConfirmFormControlName = 'confirmPassword') {

    return (group: FormGroup) => {

      if (!group.get(passwordFormControlName) || !group.get(passwordConfirmFormControlName)) {
        throw new Error("The group for the password match does not contain a password and/or containPassword control!");
      }

      let password = group.get(passwordFormControlName).value; // to get value in input tag
      let confirmPassword = group.get(passwordConfirmFormControlName).value; // to get value in input tag

      if (password != confirmPassword) {
        group.get(passwordConfirmFormControlName).setErrors({matchPassword: true})
      } else {
        return null
      }

    };

  }


}



// WEBPACK FOOTER //
// ./src/app/core/visbos-core/components/password-change/password-change.validator.ts